// 商品与搜索：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 移动商品
export const mobileProduct = Object.freeze({
  "mobile.product.back": "返回",
  "mobile.product.home": "首页",
  "mobile.product.share": "分享",
  "mobile.product.inspected": "已验货",
  "mobile.product.viewInspectionImages": "查看验货图片",
  "mobile.product.remaining": "余{count}",
  "mobile.product.minimumOrder": "起订",
  "mobile.product.approximately": "约",
  "mobile.product.sourceLocation": "货源地",
  "mobile.product.batch": "批次",
  "mobile.product.days": "天",
  "mobile.product.deliveryDays": "交货天数",
  "mobile.product.sectionNavigation": "商品详情页内导航",
  "mobile.product.parameters": "参数",
  "mobile.product.specification": "规格书",
  "mobile.product.contactInfo": "联系方式",
  "mobile.product.substitutes": "替代产品",
  "mobile.product.parameterInfo": "参数信息",
  "mobile.product.basicParameters": "基础参数",
  "mobile.product.brand": "品牌",
  "mobile.product.partNumber": "料号",
  "mobile.product.copyPartNumber": "复制料号",
  "mobile.product.batchDc": "批次（DC）",
  "mobile.product.manufacturer": "厂家",
  "mobile.product.validityPeriod": "有效期",
  "mobile.product.originProof": "原产地证明",
  "mobile.product.yes": "有",
  "mobile.product.no": "无",
  "mobile.product.condition": "货物情况",
  "mobile.product.physicalSpecs": "物理规格",
  "mobile.product.weight": "重量",
  "mobile.product.dimensions": "尺寸",
  "mobile.product.length": "长度",
  "mobile.product.width": "宽度",
  "mobile.product.height": "高度",
  "mobile.product.categoryAttributes": "分类属性",
  "mobile.product.productCategory": "产品分类",
  "mobile.product.aiAnswer": "先搜 AI 解答",
  "mobile.product.specificationPdf": "规格书 PDF",
  "mobile.product.loading": "加载中",
  "mobile.product.preview": "点击预览",
  "mobile.product.downloadSpecification": "下载规格书",
  "mobile.product.download": "下载",
  "mobile.product.noSpecification": "暂无规格书",
  "mobile.product.viewNegotiatorProfile": "查看谈判人主页",
  "mobile.product.negotiator": "谈判人",
  "mobile.product.chatOnline": "在线沟通",
  "mobile.product.phoneNumber": "联系电话",
  "mobile.product.copyPhone": "复制电话",
  "mobile.product.callPhone": "拨打电话",
  "mobile.product.call": "拨打",
  "mobile.product.wechatId": "微信号",
  "mobile.product.copyWechatId": "复制微信号",
  "mobile.product.noSubstitutes": "暂无替代产品",
  "mobile.product.favorited": "已收藏",
  "mobile.product.favorite": "收藏",
  "mobile.product.contact": "联系",
  "mobile.product.addToCart": "加入购物车",
  "mobile.product.quickOrder": "快捷下单",
  "mobile.product.contactService": "客服咨询",
  "mobile.product.submitPurchaseIntent": "提交购买意向",
  "mobile.product.expectedPrice": "期望价格",
  "mobile.product.price": "价格",
  "mobile.product.quantity": "数量",
  "mobile.product.buyerName": "买家姓名",
  "mobile.product.enterBuyerName": "请填写买家姓名",
  "mobile.product.buyerPhone": "买家手机号",
  "mobile.product.enterBuyerPhone": "请填写买家手机号",
  "mobile.product.deliveryAddress": "交货地址",
  "mobile.product.enterDeliveryAddress": "请填写交货地址",
  "mobile.product.required": "不能为空",
  "mobile.product.referredNegotiator": "推荐谈判人",
  "mobile.product.enterNegotiatorPhone": "请填写推荐谈判人手机号",
  "mobile.product.chooseQuantity": "选择数量",
  "mobile.product.addedToCart": "成功加入购物车",
  "mobile.product.continueShopping": "继续选购",
  "mobile.product.goToCart": "去购物车",
  "mobile.product.shareTo": "分享到",
  "mobile.product.cancel": "取消",
  "mobile.product.wechat": "微信",
  "mobile.product.douyin": "抖音",
  "mobile.product.xiaohongshu": "小红书",
  "mobile.product.weibo": "微博",
  "mobile.product.requiredField": "必填项",
  "mobile.product.enterValidNumber": "请填写有效的数字",
  "mobile.product.agentService": "客服",
  "mobile.product.online": "在线",
  "productSpecification.loginRequired": "登录后可查看或下载该规格书。",
  "productSpecification.notNow": "暂不登录",
  "productSpecification.accessDenied": "暂无权限查看该规格书。",
  "productSpecification.notFound": "规格书不存在或已被删除。",
  "mobile.product.notice": "温馨提示",
  "mobile.product.loginRequired": "此时需要先登录才能继续操作哦",
  "mobile.product.goToLogin": "去登录",
  "mobile.product.keepBrowsing": "再逛逛",
  "mobile.product.verifyIdentityFirst": "请先登录并实名认证后再操作",
  "mobile.product.copySucceeded": "复制成功",
  "mobile.product.copyFailed": "复制失败",
  "mobile.product.verifyIdentity": "请先实名认证后再操作!",
  "mobile.product.insufficientStock": "当前库存不足，无法加入购物车",
  "mobile.product.enterQuantity": "请输入数量",
  "mobile.product.belowMinimumQuantity":
    "加入购物车数量需大于起订量（{quantity}）",
  "mobile.product.notBoundBuyer": "您不是该商品的绑定用户，无法加入购物车",
  "mobile.product.confirmBoundPhone": "绑定手机号确认",
  "mobile.product.boundPhoneQuestion":
    "商品绑定手机号：{phone}，是您本人使用？",
  "mobile.product.confirm": "确定",
  "mobile.product.purchaseIntentSubmitted":
    "提交订购意向成功！请等待商务接单！",
  "mobile.product.specificationUrlFailed": "规格书地址获取失败，请稍后重试",
  "mobile.product.sharedTo": "分享到：{name}",
});

// 移动搜索
export const mobileSearch = Object.freeze({
  "mobile.search.backHome": "返回首页",
  "mobile.search.ai": "先搜AI",
  "mobile.search.all": "综合",
  "mobile.search.products": "商品",
  "mobile.search.wiki": "百科",
  "mobile.search.wikiResults": "百科结果",
  "mobile.search.productResults": "商品结果",
  "mobile.search.allResults": "综合结果",
  "mobile.search.resultCount": "共 {count} 条",
  "mobile.search.searching": "搜索中",
  "mobile.search.noResults": "暂无相关结果",
  "mobile.search.publisher": "发布者：{name}",
  "mobile.search.userPublished": "用户发布",
  "mobile.search.priceOnRequest": "价格面议",
  "mobile.search.stockUnconfirmed": "库存待确认",
  "mobile.search.viewDetails": "查看详情",
  "mobile.search.recentSearches": "最近搜索",
  "mobile.search.clearHistory": "清空搜索历史",
  "mobile.search.wikiSearchFailed": "百科搜索失败，请稍后重试",
  "mobile.search.searchFailed": "搜索失败，请稍后重试",
  "mobile.search.productList": "商品列表",
  "mobile.search.searchProducts": "搜索商品",
  "mobile.search.sales": "销量",
  "mobile.search.price": "价格",
});

// 桌面商品
export const desktopProduct = Object.freeze({
  "pcProduct.seller": "卖家",
  "pcProduct.back": "返回",
  "pcProduct.mainImage": "商品主图",
  "pcProduct.thumbnail": "缩略图",
  "pcProduct.inspected": "已验货",
  "pcProduct.share": "转发分享",
  "pcProduct.wechat": "微信",
  "pcProduct.weibo": "微博",
  "pcProduct.douyin": "抖音",
  "pcProduct.xiaohongshu": "小红书",
  "pcProduct.details": "产品详情",
  "pcProduct.validity": "有效期",
  "pcProduct.manufacturer": "厂家",
  "pcProduct.deliveryDays": "交货天数",
  "pcProduct.daysValue": "{count}天",
  "pcProduct.weight": "重量",
  "pcProduct.originProof": "原产地证明",
  "pcProduct.yes": "有",
  "pcProduct.no": "无",
  "pcProduct.dimensions": "尺寸",
  "pcProduct.applications": "应用标签",
  "pcProduct.category": "产品分类",
  "pcProduct.categoryAttributes": "分类属性",
  "pcProduct.contactDetails": "联系方式",
  "pcProduct.contactPerson": "联系人",
  "pcProduct.negotiatorSuffix": "（谈判人）",
  "pcProduct.phone": "联系电话",
  "pcProduct.wechatId": "微信号",
  "pcProduct.consultNegotiator": "在线咨询谈判人",
  "pcProduct.specification": "规格书",
  "pcProduct.specLoading": "规格书加载中",
  "pcProduct.downloadSpec": "下载规格书",
  "pcProduct.fullScreen": "全屏查看",
  "pcProduct.substitutes": "替代产品",
  "pcProduct.brand": "品牌",
  "pcProduct.partNumber": "料号",
  "pcProduct.price": "价格",
  "pcProduct.approximately": "约",
  "pcProduct.minimumOrderSuffix": "起订",
  "pcProduct.stock": "库存",
  "pcProduct.goodsCondition": "货物情况",
  "pcProduct.specPartNumber": "规格料号",
  "pcProduct.batch": "批次",
  "pcProduct.sourceLocation": "货源地",
  "pcProduct.minimumOrder": "起订量",
  "pcProduct.quantity": "数量",
  "pcProduct.favorite": "收藏",
  "pcProduct.contact": "联系",
  "pcProduct.addToCart": "加入购物车",
  "pcProduct.quickOrder": "快捷下单",
  "pcProduct.agentService": "客服咨询",
  "pcProduct.addedToCart": "成功加入购物车",
  "pcProduct.addedToCartDetail": "商品已添加到您的购物车",
  "pcProduct.productImage": "商品图片",
  "pcProduct.continueShopping": "继续选购",
  "pcProduct.checkoutCart": "去购物车结算",
  "pcProduct.required": "必填项",
  "pcProduct.validNumber": "请填写有效的数字",
  "pcProduct.aiAnswers": "先搜AI解答",
  "pcProduct.loginAndVerifyFirst": "请先登录并且实名认证后再操作!",
  "pcProduct.copySuccess": "复制成功",
  "pcProduct.copyFailed": "复制失败",
  "pcProduct.confirmBoundPhone": "商品绑定手机号：{phone}，是您本人使用？",
  "pcProduct.boundPhoneTitle": "绑定手机号确认",
  "pcProduct.confirm": "确定",
  "pcProduct.cancel": "取消",
  "pcProduct.verifyFirst": "请先实名认证后再操作!",
  "pcProduct.notBoundBuyer": "您不是该商品的绑定用户，无法加入购物车",
  "pcProduct.insufficientStock": "当前库存不足，无法加入购物车",
  "pcProduct.belowMinimum": "加入购物车数量需大于起订量（{quantity}）",
});

// 桌面搜索
export const desktopSearch = Object.freeze({
  "pcSearch.placeholder": "搜索料号、名称、品牌、百科、供需",
  "pcSearch.clear": "清空",
  "pcSearch.search": "先搜一下",
  "pcSearch.ai": "先搜AI",
  "pcSearch.all": "综合",
  "pcSearch.product": "商品",
  "pcSearch.wiki": "百科",
  "pcSearch.supplyDemand": "供需",
  "pcSearch.bidding": "竞标",
  "pcSearch.index": "指数",
  "pcSearch.user": "用户",
  "pcSearch.resultSummary": "找到 {count} 条与“{keyword}”相关的{type}结果",
  "pcSearch.enterKeyword": "输入关键词后可搜索全站内容",
  "pcSearch.priceOnRequest": "价格面议",
  "pcSearch.stockPending": "库存待确认",
  "pcSearch.stockCount": "库存 {count}{unit}",
  "pcSearch.viewDetails": "查看详情",
  "pcSearch.pagination": "搜索结果分页",
  "pcSearch.previousPage": "上一页",
  "pcSearch.nextPage": "下一页",
  "pcSearch.searching": "正在搜索...",
  "pcSearch.noResults": "没有找到匹配结果",
  "pcSearch.tryAnotherKeyword":
    "可以换成料号、品牌、百科名称或商品名称再试一次。",
  "pcSearch.enterSearchText": "请输入搜索内容",
  "pcSearch.productQueryFailed": "商品查询接口暂时异常，请稍后再试。",
  "pcSearch.wikiQueryFailed": "百科查询接口暂时异常，请稍后再试。",
  "pcSearch.wikiEntry": "百科词条",
  "pcSearch.communityWiki": "用户百科",
  "pcSearch.datasheetAvailable": "已收录规格书",
  "pcSearch.communityPublished": "用户发布",
  "pcSearch.publishedBy": "发布者：{name}",
  "pcSearch.skHynix": "海力士",
  "pcSearch.datasheet": "规格书",
});

// 规格书
export const specification = Object.freeze({
  "pcSpecification.title": "规格书管理",
  "pcSpecification.subtitle": "查看当前账号已下载的百科规格书",
  "pcSpecification.refresh": "刷新",
  "pcSpecification.empty": "暂无已下载的规格书",
  "pcSpecification.partNumber": "规格书料号",
  "pcSpecification.points": "消耗积分",
  "pcSpecification.downloadedAt": "下载时间",
  "pcSpecification.expiresAt": "到期时间",
  "pcSpecification.status": "状态",
  "pcSpecification.valid": "有效",
  "pcSpecification.expired": "已失效",
  "pcSpecification.actions": "操作",
  "pcSpecification.viewWiki": "查看百科",
  "pcSpecification.loadFailed": "获取已下载规格书失败，请稍后重试",
  "pcSpecification.missingWiki": "未找到该规格书对应的百科词条",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "goodsLibrary.selectVideo": "请选择视频文件",
  "goodsLibrary.confirmCreate": "确认新增",
  "goodsLibrary.enterCode": "请输入商品编号",
  "goodsLibrary.imageUrlHint": "请输入或上传商品图片地址",
  "goodsLibrary.particleInformation": "颗粒信息",
  "goodsLibrary.wafer": "晶圆",
  "goodsLibrary.yield": "良率",
  "goodsLibrary.stack": "叠层",
  "goodsLibrary.priceStock": "价格库存",
  "goodsLibrary.mediaDescription": "媒体与描述",
  "goodsLibrary.wideImage": "宽屏展示图片",
  "goodsLibrary.wideImageHint": "请输入或上传宽屏展示图片地址",
  "goodsLibrary.gallery": "画册图片",
  "goodsLibrary.galleryHint": "请输入或上传画册图片，多张以逗号分割",
  "goodsLibrary.videoUrl": "视频url",
  "goodsLibrary.videoHint": "请输入或上传视频url",
  "goodsLibrary.sellingPoints": "卖点描述",
  "goodsLibrary.sellingPointsHint": "请输入商品卖点",
  "goodsLibrary.removeFile": "移除文件",
  "goodsLibrary.chooseFromLibrary": "从库选择",
  "goodsLibrary.allowedBuyersHint": "按手机号添加允许购买该商品的买家",
  "goodsLibrary.closeSaleRange": "关闭修改可售范围弹窗",
  "goodsLibrary.newBuyerPhone": "新增买家手机号",
  "goodsLibrary.addPhonesHint": "输入手机号后点击添加，可连续添加多个买家",
  "goodsLibrary.allowedBuyers": "以下买家可购买当前商品",
  "goodsLibrary.noBuyerPhones": "暂未添加买家手机号",
  "goodsLibrary.addPhoneFirst": "请至少添加一个手机号",
  "goodsLibrary.videoLimit": "支持视频，最大{size}MB",
  "goodsLibrary.imageLimit": "支持图片，最大{size}MB",
  "goodsLibrary.enterFileUrl": "请输入或上传文件地址",
  "goodsLibrary.fileSizeLimit": "文件大小不能超过 {size}MB",
  "goodsLibrary.pageSizeOption": "每页 {size} 条",
  "goodsLibrary.bindProduct": "绑定商品",
  "goodsLibrary.offSale": "下架",
  "goodsLibrary.onSale": "上架",
  "goodsLibrary.soldOut": "已售完",
  "goodsLibrary.platformUnlisted": "平台下架",
  "goodsLibrary.storeUnavailable": "店铺不可用",
  "goodsLibrary.supplierUnlisted": "供应商下架",
  "goodsLibrary.supplierDisabled": "供应商禁用",
  "goodsLibrary.missingId": "未获取到商品 ID",
  "goodsLibrary.enterName": "请输入商品名称",
  "goodsLibrary.created": "新增成功",
  "goodsLibrary.listed": "已上架",
  "goodsLibrary.chooseExcelFormat": "请选择 xls 或 xlsx 文件",
  "goodsLibrary.chooseExcelFirst": "请先选择 Excel 文件",
  "goodsLibrary.enterPageRange": "请输入 1-{total} 之间的页码",
  "goodsLibrary.overview": "商品总览",
  "goodsLibrary.title": "商品资料库",
  "goodsLibrary.refresh": "刷新商品数据",
  "goodsLibrary.currentResults": "当前结果",
  "goodsLibrary.activeOnPage": "本页上架",
  "goodsLibrary.inactiveOnPage": "本页下架",
  "goodsLibrary.searchName": "商品名称搜索",
  "goodsLibrary.searchCode": "商品编号搜索",
  "goodsLibrary.filterStatus": "商品状态筛选",
  "goodsLibrary.salePrice": "销售价",
  "goodsLibrary.loading": "正在加载商品",
  "goodsLibrary.loadFailed": "商品数据加载失败",
  "goodsLibrary.noResults": "暂无符合条件的商品",
  "goodsLibrary.create": "新增商品",
  "goodsLibrary.pagination": "商品列表分页",
  "goodsLibrary.page": "页",
  "goodsLibrary.jumpToPage": "跳转页码",
  "goodsLibrary.actions": "商品操作",
  "goodsLibrary.edit": "修改商品",
  "goodsLibrary.listProduct": "上架商品",
  "goodsLibrary.pageSize": "每页显示数量",
  "goodsLibrary.pageNumber": "页码",
  "goodsLibrary.excelImport": "Excel 导入",
  "goodsLibrary.importTitle": "批量导入商品资料",
  "goodsLibrary.chooseExcel": "选择 Excel 文件",
  "goodsLibrary.excelFormats": "支持 xls、xlsx 格式",
  "goodsLibrary.importCompleted": "导入完成",
  "goodsLibrary.imported": "成功导入",
  "goodsLibrary.productCountUnit": "条商品",
  "goodsLibrary.duplicatePartNumbers": "重复料号",
  "goodsLibrary.startImport": "开始导入",
});

// PC界面显示文案；不改动业务原值。
export const productFixedFacts = Object.freeze({
  "pcProduct.whiteLabel": "白牌",
  "pcProduct.factorySealedBox": "原箱原封",
  "pcProduct.originalFactoryPackaging": "原厂原包",
  "pcProduct.nonFactoryPackaging": "非原厂原包",
  "pcProduct.conditionSeparator": "，",
  "pcProduct.quantityWithUnit": "{count}{unit}",
  "pcProduct.unitPiece": "个",
  "pcProduct.unitItem": "件",
  "pcProduct.unitBox": "箱",
  "pcProduct.unitSet": "套",
});

// 页面受控选项与属性显示；原始业务值保持不变。
export const attributeDisplayFollowup = Object.freeze({
  "pcProduct.unitMilligram": "毫克",
  "pcProduct.unitKilogram": "千克",
  "pcProduct.unitKilogramColloquial": "公斤",
  "pcProduct.attributePackage": "封装",
  "pcProduct.attributeColor": "颜色",
  "pcProduct.colorBlue": "蓝色",
  "pcProduct.colorRed": "红色",
  "pcProduct.colorBlack": "黑色",
  "pcProduct.colorWhite": "白色",
  "pcProduct.factoryOpenedBox": "原箱已拆封",
});

export const goodsFeedback = Object.freeze({
  "goodsFeedback.confirmList": "确认上架“{name}”吗？",
  "goodsFeedback.confirmDeleteGoods": "删除后不可恢复，确认删除“{name}”吗？",
});


// 搜索结果展示：PC 与移动端共用。
export const searchResultsPresentation = Object.freeze({
  "searchResults.aiTitle": "先搜 AI",
  "searchResults.basicInfo": "基本信息",
  "searchResults.executionComplete": "执行完成",
  "searchResults.candidateHint": "当前输入可能缺少后缀或存在字符混淆，请核对以下实际候选型号。",
  "searchResults.partialIntro": "已找到该料号的部分资料，",
  "searchResults.remainingUnknown": "其余参数待确认",
  "searchResults.compareHeading": "对比参数",
  "searchResults.noAlternatives": "暂未取得有依据的替代候选，不能确认可直接替换。",
  "searchResults.questionAnswer": "{model}：{parameter}为 {value}。",
  "searchResults.sources": "资料来源",
  "searchResults.difference": "差异",
  "searchResults.parameterName": "名称",
  "searchResults.parameterDescription": "描述",
  "searchResults.parameterLabel": "料号参数",
  "searchResults.noImage": "暂无图片",
  "searchResults.aiTemporaryResult": "AI 临时结果",
  "searchResults.standardAnswerSource": "标准答案 · AI说明待确认",
  "searchResults.wikiPartialUnavailable": "部分百科来源暂时无法加载，已展示可用结果。",
  "searchResults.noPrice": "价格待确认",
  "searchResults.noStock": "库存待确认",
  "searchResults.aiEmptyTitle": "暂未找到可靠资料",
  "searchResults.aiEmptyDescription": "暂未获得“{keyword}”的有效资料，无法提供准确的参数信息。",
  "searchResults.aiLoginTitle": "登录后查看 AI 解读",
  "searchResults.aiLoginDescription": "登录后可查询该关键词的 AI 解读。",
  "searchResults.aiLogin": "去登录",
  "searchResults.checkLabel": "建议核对",
  "searchResults.checkModel": "完整料号",
  "searchResults.checkModelDescription": "检查是否存在漏字、空格或字符混淆。",
  "searchResults.checkBrand": "品牌信息",
  "searchResults.checkBrandDescription": "补充制造商品牌，有助于缩小查找范围。",
  "searchResults.checkSuffix": "型号后缀",
  "searchResults.checkSuffixDescription": "核对芯片丝印或完整订货型号。",

  "searchResults.platformProducts": "平台商品",
  "searchResults.similarProducts": "相似商品",
  "searchResults.popularSearches": "大家都在搜",
  "searchResults.weeklyProducts": "本周热料",
  "searchResults.matchedCount": "匹配当前搜索 · {count} 件",
  "searchResults.viewAll": "查看全部商品（共 {count} 件）",
  "searchResults.moreProducts": "更多商品",
  "searchResults.similarHint": "同品牌或相近料号，替代使用前请核对规格与兼容性。",
  "searchResults.similarLoading": "正在查询相似商品…",
  "searchResults.noSimilar": "暂未找到其他相似商品",
  "searchResults.fallbackPopular": "暂无热搜数据",
  "searchResults.popularLoading": "正在加载热搜…",
  "searchResults.noPopular": "暂无热搜数据",
  "searchResults.popularityUnavailable": "热度数据暂时无法加载",
  "searchResults.goodsLoading": "正在加载商品…",
  "searchResults.noRecommended": "暂无推荐商品",
  "searchResults.expandAi": "展开完整 AI 解读",
  "searchResults.collapseAi": "收起 AI 解读",
  "searchResults.tryAlso": "也可试试",
  "searchResults.noDetail": "暂无详情",
  "searchResults.purchase": "去购买",
  "searchResults.viewProduct": "查看商品",
  "searchResults.wikiUnavailable": "百科服务暂时无法加载，请稍后重试",
});

export const searchDataPresentation = Object.freeze({
  "searchData.currentModel": "当前型号",
  "searchData.compatibility": "兼容结论",
  "searchData.selectionAdvice": "选型参考",
  "searchData.selectModel": "查询此型号",
  "searchData.coverageStart": "数据开始积累于 {time}（北京时间）",

  "searchData.model": "料号",
  "searchData.brand": "品牌",
  "searchData.ambiguous": "暂时无法确定完整型号，请确认您要查找的料号。",
  "searchData.conflict": "资料存在差异",
  "searchData.unknown": "待确认",
  "searchData.parameter": "参数",
  "searchData.comparison": "型号参数对比表，可横向滚动",
  "searchData.alternatives": "候选型号对比",
  "searchData.verified": "已验证可直接替代",
  "searchData.candidate": "候选，适用条件及兼容性待核对",
  "searchData.similarUnavailable": "相似商品暂时无法加载，请稍后重试",
  "searchData.hotProducts": "本周热料",
  "searchData.field.brand": "品牌",
  "searchData.field.productType": "产品类型",
  "searchData.field.capacity": "颗粒容量",
  "searchData.field.bitWidth": "位宽",
  "searchData.field.speed": "频率 / 速率",
  "searchData.field.frequency": "频率",
  "searchData.field.package": "封装 / 球位",
  "searchData.field.ball": "球位",
  "searchData.field.voltage": "工作电压",
  "searchData.field.pins": "引脚数量",
  "searchData.field.ddr": "DDR代际",
  "searchData.field.density": "密度",
  "searchData.field.organization": "组织",
  "searchData.field.yield": "良率",
  "searchData.field.pinout": "引脚定义",
  "searchData.field.timing": "时序",
  "searchData.field.ballPitch": "焊球间距",
  "searchData.field.controller": "主控兼容条件",
  "searchData.field.pcbValidation": "PCB验证",
  "searchData.source.mall": "平台商品",
  "searchData.source.erp": "ERP录入",
  "searchData.source.partNumber": "料号库",
  "searchData.source.knowledge": "知识库",
  "searchData.source.rule": "规则解析",
  "searchData.source.reviewed": "已审核资料",
  "searchData.source.specification": "规格书",
  "searchData.review.recorded": "平台录入",
  "searchData.review.parsed": "解析结果",
  "searchData.review.approved": "审核通过",
});

export const messages = Object.freeze({
  ...searchDataPresentation,
  ...searchResultsPresentation,
  ...goodsFeedback,
  ...attributeDisplayFollowup,
  ...productFixedFacts,
  ...mobileWorkflow,
  "goodsRecognition.examples":
    "例一：M321RAJA0MB0-CWM usd 4350.0*500 pcs,  25+ NON CN , 1-2days\n例二：公司现货 月底冲量放价 欢迎实单滴滴 KLM4G1FETE-B041  25+  12800",
  ...mobileProduct,
  ...mobileSearch,
  ...desktopProduct,
  ...desktopSearch,
  ...specification,
});
